import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Gift, Sparkle, Heart, Cupcake, Flower } from "../doodles/Doodles";

const TILES = [
  {
    to: "/combos",
    bg: "#FFE4E4",
    iconBg: "#FFF",
    title: "Combo Party Orders",
    subtitle: "Birthdays · Bridal · Baby showers",
    badge: "Hyderabad only",
    icon: Cupcake,
    iconProps: {},
    testid: "bulk-orders-combos",
  },
  {
    to: "/trousseau",
    bg: "#FFF1D6",
    iconBg: "#FFF",
    title: "Trousseau Packing",
    subtitle: "Engagements · Weddings · Keepsakes",
    badge: "Hyderabad only",
    icon: Flower,
    iconProps: { color: "#FF6B9D" },
    testid: "bulk-orders-trousseau",
  },
  {
    to: "/catalogues",
    bg: "#E7F4FF",
    iconBg: "#FFF",
    title: "View our Catalogues",
    subtitle: "Return gifts · Corporate · Weddings",
    badge: null,
    icon: Gift,
    iconProps: { color: "#FF6B9D" },
    testid: "bulk-orders-view-catalogues",
  },
];

export default function BulkOrdersHub() {
  return (
    <section className="section-y relative overflow-hidden" data-testid="bulk-orders-hub-section">
      <Sparkle color="#FFD93D" className="absolute top-8 left-12 w-5 animate-twinkle"/>
      <Heart color="#FF6B9D" className="absolute bottom-10 right-14 w-6 animate-bounce-doodle"/>
      <Gift color="#DDC5FF" className="absolute top-1/2 right-10 w-8 animate-float-slow hidden md:block"/>
      <Gift color="#BAE1FF" className="absolute bottom-8 left-10 w-7 animate-float-fast hidden md:block"/>

      <div className="container-x flex flex-col items-center">
        <div className="text-center max-w-md">
          <p className="label-small text-xs sm:text-sm">📦 For Events &amp; Celebrations 📦</p>
          <h2 className="font-doodle text-2xl sm:text-3xl mt-1 text-[#2D2424]">
            Planning a <span className="text-[#FF6B9D]">big day</span>?
          </h2>
        </div>

        {/* Vertical stack of 3 tiles (Combos → Trousseau → Catalogues) */}
        <div className="mt-6 flex flex-col gap-3 w-full max-w-xl">
          {TILES.map((t) => {
            const Icon = t.icon;
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={t.testid}
                className="group doodle-card overflow-hidden text-left hover:-translate-y-0.5 transition-transform"
                style={{ backgroundColor: t.bg, boxShadow: "5px 5px 0 #2D2424" }}
              >
                <div className="p-4 sm:p-5 flex items-center gap-4">
                  <div
                    className="shrink-0 w-14 h-14 rounded-full border-2 border-[#2D2424] flex items-center justify-center"
                    style={{ backgroundColor: t.iconBg, boxShadow: "2px 2px 0 #2D2424" }}
                  >
                    <Icon className="w-9 h-9" {...t.iconProps}/>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="font-doodle text-xl text-[#2D2424] leading-none">{t.title}</p>
                      {t.badge && (
                        <span
                          className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#FFD93D] text-[#7A1F2B] text-[10px] font-doodle uppercase tracking-wider rounded-full border border-[#7A1F2B]"
                          data-testid={`${t.testid}-badge`}
                        >
                          <MapPin className="w-3 h-3"/> {t.badge}
                        </span>
                      )}
                    </div>
                    <p className="font-hand text-[12px] text-[#5C5555] mt-1">{t.subtitle}</p>
                  </div>
                  <ArrowRight className="w-5 h-5 text-[#7A1F2B] group-hover:translate-x-1 transition-transform shrink-0" strokeWidth={2}/>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
